/** Shared library controls, mirrored by HobbyLibraryStrings on iOS. */
export const libraryControlsStrings = { filters: 'Filters', favorites: 'Favorites', reset: 'Reset', done: 'Done', all: 'All', clearSearch: 'Clear search' };
